import { ReactNode } from 'react';
import cn from 'classnames';

import styles from './Footer.module.scss';
export type CardFooterProps = {
  children: ReactNode;
  size?: 'medium' | 'large';
};

const CardFooter = ({ children, size = 'medium' }: CardFooterProps) => (
  <div className={cn(styles.root, styles[size])}>{children}</div>
);

export default CardFooter;
